import React from 'react';
import { useTranslate } from 'react-admin';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import { getCompatibleTextColor, ZIPPITY_COLORS } from '../../calendar/colors';
import { formatScheduleTypeName } from '../../helper';

const styles = {
  chipMargin: {
    margin: '3px 5px 3px 0',
  },
};

const getColor = (name) => {
  const knownValues = [
    'mechanical',
    'fuel',
    'detailing',
    'tires',
    'oil',
    'state_inspection',
  ];

  const index = knownValues.indexOf(name);
  if (index >= 0) {
    return ZIPPITY_COLORS[index % ZIPPITY_COLORS.length];
  }
  return null;
};

const ScheduleTypeChipsField = withStyles(styles)(
  ({ record, source, classes }) => {
    const translate = useTranslate();
    const types = record[source];
    if (!types) {
      return null;
    }
    types.sort();
    return types.map((item) => {
      const backgroundColor = getColor(item);
      const color = getCompatibleTextColor(backgroundColor);
      return (
        <Chip
          key={item}
          label={formatScheduleTypeName(item, translate)}
          style={{ backgroundColor, color, fontSize: '11px' }}
          className={classes.chipMargin}
        />
      );
    });
  },
);
ScheduleTypeChipsField.defaultProps = {
  label: 'Schedule Types',
  source: 'schedule-types',
};

export default ScheduleTypeChipsField;
